import React, { ReactNode } from 'react';
import './Button.css';

interface ButtonProps {
    children: ReactNode;
    onClick?: () => void;
    type?: 'button' | 'submit' | 'reset';
    variant?: 'primary' | 'secondary';
    disabled?: boolean;
    loading?: boolean;
    className?: string;
}

const Button: React.FC<ButtonProps> = ({
                                           children,
                                           onClick,
                                           type = 'button',
                                           variant = 'primary',
                                           disabled = false,
                                           loading = false,
                                           className = '',
                                       }) => {
    return (
        <button
            type={type}
            onClick={onClick}
            disabled={disabled || loading}
            className={`btn btn-${variant} ${className} ${loading ? 'loading' : ''}`}
        >
            {loading && <span className="loading-spinner"></span>}
            {children}
        </button>
    );
};

export default Button;